/**
 * Числительные: счёт в шапке и число внутри фразы.
 *
 * Суффиксы `_one`/`_few`/`_many` — русские формы числа. Какую взять, решает
 * `Intl.PluralRules`; наше дело — написать все три. Несклоняемому слову
 * («досье») хватает одного ключа без суффиксов.
 */
export const counts = {
  /* ── Счёт: сколько всего в списке ───────────────────────────────────── */
  count: {
    dossier: '{{count}} досье',

    face_one: '{{count}} внешка',
    face_few: '{{count}} внешки',
    face_many: '{{count}} внешек',

    decision_one: '{{count}} решение',
    decision_few: '{{count}} решения',
    decision_many: '{{count}} решений',

    version_one: '{{count}} версия',
    version_few: '{{count}} версии',
    version_many: '{{count}} версий',

    item_one: '{{count}} предмет',
    item_few: '{{count}} предмета',
    item_many: '{{count}} предметов',

    pet_one: '{{count}} питомец',
    pet_few: '{{count}} питомца',
    pet_many: '{{count}} питомцев',

    ability_one: '{{count}} способность',
    ability_few: '{{count}} способности',
    ability_many: '{{count}} способностей',
  },

  /* ── Число внутри фразы ─────────────────────────────────────────────── */
  plural: {
    startingAbility_one: '{{count}} стартовая',
    startingAbility_few: '{{count}} стартовых',
    startingAbility_many: '{{count}} стартовых',

    unreadDecision_one: '{{count}} новое',
    unreadDecision_few: '{{count}} новых',
    unreadDecision_many: '{{count}} новых',
  },
} as const;
